<div class="payment-cancel-container ">
  <div class="card p-3">
    <div class="message-box">
      <p class="cancel-message">The payment was cancelled. No amount was deducted from your credit card.<br></p>
      <p class="cancel-message">Please click on proceed to continue with payment.</p>
    </div>
    <div class="button-group">
      <button class="btn btn-primary home-btn d-flex align-self-end" (click)="onRetryPayment()">Proceed</button>
    </div>
  </div>
</div>
